import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environment';

@Injectable({
  providedIn: 'root'
})
export class OrdersService {

  constructor(private http: HttpClient) { }

  saveOrders(data) {
    return this.http.put(
      `${environment.apiHost}/v1/purchase-order`,
      data
    );
  }

  updateOrders(data) {
    return this.http.patch(
      `${environment.apiHost}/v1/purchase-order`,
      data
    );
  }

  get(data) {
    return this.http.post(
      `${environment.apiHost}/v1/purchase-order`,
      data
    );
  }

  getEnterprises(data) {
    return this.http.post(
      `${environment.apiHost}/v1/vendor`,
      data
    );
  }

  updateStatus(data) {
    return this.http.patch(
      `${environment.apiHost}/v1/purchase-order-inform/update-status`,
      data
    );
  }
}
